var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333252,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#E5A240",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8633 15.77C25.7933 15.76 25.7233 15.76 25.6533 15.77C24.1033 15.72 22.8733 14.45 22.8733 12.89C22.8733 11.3 24.1633 10 25.7633 10C27.3533 10 28.6533 11.29 28.6533 12.89C28.6433 14.45 27.4133 15.72 25.8633 15.77Z",
    fill: "#E5A240"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1232 22.7004C28.0032 23.4504 26.4332 23.7304 24.9832 23.5404C25.3632 22.7204 25.5632 21.8104 25.5732 20.8504C25.5732 19.8504 25.3532 18.9004 24.9332 18.0704C26.4132 17.8704 27.9832 18.1504 29.1132 18.9004C30.6932 19.9404 30.6932 21.6504 29.1232 22.7004Z",
    fill: "#E5A240"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7733 15.77C14.8433 15.76 14.9133 15.76 14.9833 15.77C16.5333 15.72 17.7633 14.45 17.7633 12.89C17.7633 11.29 16.4733 10 14.8733 10C13.2833 10 11.9933 11.29 11.9933 12.89C11.9933 14.45 13.2233 15.72 14.7733 15.77Z",
    fill: "#E5A240"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8832 20.8506C14.8832 21.8206 15.0932 22.7406 15.4732 23.5706C14.0632 23.7206 12.5932 23.4206 11.5132 22.7106C9.93325 21.6606 9.93325 19.9506 11.5132 18.9006C12.5832 18.1806 14.0932 17.8906 15.5132 18.0506C15.1032 18.8906 14.8832 19.8406 14.8832 20.8506Z",
    fill: "#E5A240"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2033 25.9406C15.6933 26.9506 15.6933 28.6106 17.2033 29.6106C18.9233 30.7606 21.7433 30.7606 23.4633 29.6106C24.9733 28.6006 24.9733 26.9406 23.4633 25.9406C21.7533 24.7906 18.9333 24.7906 17.2033 25.9406Z",
    fill: "#E5A240"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg02);
export default __webpack_public_path__ + "static/media/02.c37bbd1d087676db42c4cdc1a767f025.svg";
export { ForwardRef as ReactComponent };